import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Modal } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { SpinnerCircular } from "spinners-react";

const Knowledgebasedocument = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fileModal, setFileModal] = useState(false);
  const [addAction, setAddAction] = useState(false);
  const [questionInput, setQuestionInput] = useState("");
  const [responseInput, setResponseInput] = useState("");
  const [knowledgeInput, setKnowledgeInput] = useState("");

  const [uploadModal, setUploadModal] = useState(false);
  const [selectModal, setSelectModal] = useState(false);
  const [faqModal, setFaqModal] = useState(false);

  const [show, setShow] = useState(false);
  const [questions, setQuestion] = useState([]);

  const navigate = useNavigate();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  //Loading
  const [isLoading, setIsLoading] = useState(false)

  const location = useLocation();
  // useEffect(() => {
  //   // Set the scriptResponse from location.state when the component mounts
  //   setKnowledgeInput(location?.state?.knowledgeResponse.questions);
  //   console.log(location?.state?.knowledgeResponse.questions);
  // }, [location?.state?.knowledgeResponse.questions]);
  const handleUploadDocumentPreview = () => {
    navigate("/Document_Preview");
  };
  useEffect(() => {
    if (!authToken) {
      if (location.pathname != "/register") {
        navigate("/login");
      }
    }
  }, [])

  const handleFaqModal = () => {
    setSelectModal(false);
    setFaqModal(!faqModal);
  };

  const handleManuallyAddFaq = () => {
    navigate("/Manually_Added_Doc");
  };

  const handleSelectModal = () => {
    setUploadModal(false);
    setSelectModal(!selectModal);
  };

  const handleFileModal = () => {
    setFileModal(!fileModal);
  };
  const handleActionModel = () => {
    setAddAction(!addAction);
  };

  const handleQuestionInput = (e) => {
    setQuestionInput(e.target.value);
  };

  const handleResponseInput = (e) => {
    setResponseInput(e.target.value);
  };
  const handleDeleteModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  var authToken = localStorage.getItem("bearerToken")

  const getAllQuestions = async () => {
    try {
      setIsLoading(true)
      console.log("Fetching Qs");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/questions/${location?.state?.knowledgeId}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        setIsLoading(false)
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log(data);
      setQuestion(data.responce);
      console.log(data);
      setIsLoading(false)
    } catch (error) {
      console.error("Error fetching agent:", error);
      setIsLoading(false)
    }
  };

  useEffect(() => {
    getAllQuestions();
  }, []);
  return (
    <>
      <div className="knowledgebase_doc">
        {isLoading && (
          <>
            <div className="loader">
              <SpinnerCircular
                color="#ffffff"
                size={"20%"}
                thickness={150}
                secondaryColor="#32C0BE"
              />
              <span className="customLoadingText">Loading...</span>
            </div>
          </>
        )}
        <div className="header_doc mt-3">
          <h3>User Enter Document Name</h3>
          <div className="form">
            <Icon icon="basil:search-outline" color="#9ca3af" />
            <input
              type="text"
              className="form-control form-input"
              placeholder="Search..."
            />
          </div>
        </div>

        <div className="main-section mt-5">
          {/* <div className="upload-file " onClick={handleSelectModal}>
            <div className="contentt">
              <Icon icon="tabler:upload" width="40" height="40" />
              <p>Add To Knowledge Base</p> */}
          {/* <input type="file" name="" id="" /> */}
          {/* </div>
          </div> */}
          {/* 1st Box */}
          <>
            {questions && questions.length > 0 ?
              questions.map((item, index) => {
                return (
                  <div className="databox" key={index}>
                    <div className="para1 " onClick={handleShow}>
                      {/* <h5>"Who am i speaking with right now?"</h5> */}
                      <h5>{item.question}</h5>
                      <p className="Speak mt-4">{item.answer}</p>
                      {/* <p className="Speak mt-4">
                    "Oh, you're speaking with Haris. Nice To meet you!"
                  </p> */}
                    </div>
                    <div className="bottom">
                      <Icon
                        icon="mdi-light:delete"
                        color="black"
                        onClick={handleDeleteModal}
                      />
                      <button className="Add-btn" onClick={handleActionModel}>
                        <Icon icon="iconamoon:lightning-1-fill" color="#FFC83D" />
                        Add Action
                      </button>
                    </div>
                  </div>
                );
              }) : <></>}
          </>
          {/* 2nd Box */}
          {/* <div className="databox">
            <div className="para1" onClick={handleShow}>
              <h5>"Who am i speaking with right now?"</h5>
              <p className="Speak mt-4">
                "Oh, you're speaking with Haris. Nice To meet you!"
              </p>
            </div>
            <div className="bottom">
              <Icon
                icon="mdi-light:delete"
                color="black"
                onClick={handleDeleteModal}
              />
              <button className="Add-btn" onClick={handleActionModel}>
                <Icon icon="iconamoon:lightning-1-fill" color="#FFC83D" />
                Add Action
              </button>
            </div>
          </div> */}
          {/* 3rd Box */}
          {/* <div className="databox">
            <div className="para1" onClick={handleShow}>
              <h5>"Who am i speaking with right now?"</h5>
              <p className="Speak mt-4">
                "Oh, you're speaking with Haris. Nice To meet you!"
              </p>
            </div>
            <div className="bottom">
              <Icon
                icon="mdi-light:delete"
                color="black"
                onClick={handleDeleteModal}
              />
              <button className="Add-btn" onClick={handleActionModel}>
                <Icon icon="iconamoon:lightning-1-fill" color="#FFC83D" />
                Add Action
              </button>
            </div>
          </div> */}
        </div>
        {/* ADD TO KNOWLEDGE BASE  */}
        <Modal show={selectModal} onHide={handleSelectModal} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Add to Knowledge Base</Modal.Title>
          </Modal.Header>
          <Modal.Body className="after-upload-modal">
            <div className="create-AI">
              <div className="top">
                <p className="text-center">
                  Do you want AI magically turn documents or call recordings
                  into FAQ flashcards or add them manually?
                </p>
              </div>
              <div className="bottom mt-3">
                <div className="checks mt-2">
                  <div className="check-boxes" onClick={handleFaqModal}>
                    <label htmlFor="#">
                      <input type="radio" name="radio-button" id="1" />
                      <p id="">Manually add FAQ flashcard</p>
                    </label>
                  </div>
                  <div className="check-boxes" onClick={handleFileModal}>
                    <label htmlFor="#">
                      <input type="radio" name="radio-button" id="2" />
                      <p id="">Upload documents</p>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        {/* Manually Add FAQ's */}
        <Modal show={faqModal} onHide={setFaqModal} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Create A Flash Card</Modal.Title>
          </Modal.Header>
          <Modal.Body className="manually-faq-body">
            <div className="top">
              <h6>Question/Objection</h6>
              <input
                type="text"
                name=""
                id=""
                placeholder="eg. What's the name of your company?"
              />
            </div>
            <div className="bottom mt-3">
              <h6>Answer/Response</h6>
              <textarea
                name=""
                id=""
                cols="30"
                rows="5"
                placeholder="eg. Tesla Super Computers"
              ></textarea>
            </div>
          </Modal.Body>
          <Modal.Footer className="manually-faq-footer">
            <div className="faq-btn">
              <button onClick={handleManuallyAddFaq}>Create</button>
            </div>
          </Modal.Footer>
        </Modal>
        {/* Upload Documents modal  */}
        <Modal show={fileModal} onHide={setFileModal} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title> </Modal.Title>
          </Modal.Header>
          <Modal.Body className="upload-documents-body">
            <div className="top">
              <h2>Upload Documents</h2>
              <p>
                Upload documents and voxr will use AI to magically turn them
                into FAQ cards
              </p>
            </div>
            <div className="bottom mt-3">
              <Icon icon="tabler:upload" width="30" height="30" />
              <input type="file" name="" id="" />
            </div>
          </Modal.Body>
          <Modal.Footer className="upload-documents-footer">
            <div className="documents-btn">
              <button onClick={handleUploadDocumentPreview}>Next</button>
            </div>
          </Modal.Footer>
        </Modal>
        {/* Update Flash Card */}
        <Modal show={show} onHide={handleClose} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Update Flash Card</Modal.Title>
          </Modal.Header>
          <Modal.Body className="manually-faq-body">
            <div className="top">
              <h6>Question/Objection</h6>
              <input
                type="text"
                name=""
                id=""
                placeholder="eg. What's the name of your company?"
                value={questionInput}
                onInput={handleQuestionInput}
              />
              {questionInput && <p>{questionInput}</p>}
            </div>
            <div className="bottom mt-3">
              <h6>Answer/Response</h6>
              <textarea
                name=""
                id=""
                cols="30"
                rows="5"
                placeholder="eg. Tesla Super Computers"
                value={responseInput}
                onChange={handleResponseInput}
              >
                {responseInput && <p>{responseInput}</p>}
              </textarea>
            </div>
          </Modal.Body>
          <Modal.Footer className="manually-faq-footer">
            <div className="faq-btn">
              <button>Update</button>
            </div>
          </Modal.Footer>
        </Modal>
        {/* Delete the card */}
        <Modal show={isModalOpen} onHide={setIsModalOpen} centered size="lg">
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body className="delete-documents-body">
            <div className="topdelete">
              <h2>Are you absolutely sure?</h2>
              <p className="del-para mt-4">
                This action cannot be undone. This will permanently delete this
                <span> knowledge card</span> from our servers.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer className="delete-documents-footer">
            <div className="delete-btn">
              <button className="removeCard">Remove Card</button>
            </div>
          </Modal.Footer>
        </Modal>
        {/*  Action Button Model */}
        <Modal show={addAction} onHide={setAddAction} centered size="lg">
          <Modal.Header closeButton>
            {/* <Modal.Title></Modal.Title> */}
          </Modal.Header>
          <Modal.Body className="manually-act-body mt-4">
            <div className="Actionbody">
              <div className="topAction">
                <h3 className="CreateNewAction">Create A New Action</h3>
                <h6 className="mt-4">Name of the action</h6>
                <input
                  type="text"
                  name=""
                  id=""
                  className="mt-2"
                  placeholder="Send $250 payment link"
                />
              </div>
              <div className="bottom mt-3">
                <h6 className="air-Agent">
                  Tell Zapier to trigger this action when your voxr Agent says
                  something like:
                </h6>
                <input
                  type="text"
                  name=""
                  id=""
                  className="mt-2"
                  placeholder="Oh, you're speaking with Haris. Nice to meet you!"
                />
              </div>
              <div className="check-Box mt-3">
                <input type="checkbox" name="subscribe" value="newsletter" />
                <label for="subscribeNews">
                  Check this box to confirm that you already have or you will
                  setup a zapier to fire for this action. Remember, if you don't
                  attach a zapier to this action, then nothing will actually
                  happen. If you want to learn how to setup a zapier to fire on
                  this action <span>click here</span>.
                </label>
              </div>
              <div className="faq-btn mt-3">
                <button className="Save_Action">Save Action</button>
              </div>
            </div>
          </Modal.Body>
          {/* <Modal.Footer className="manually-faq-footer"></Modal.Footer> */}
        </Modal>
      </div>
    </>
  );
};

export default Knowledgebasedocument;
